/**
 * 作品ごとのバックエンド種別マッピング
 *
 * "system" — system/ (port 5002, /api/v1/..., DynamoDB)
 * "app"    — app/    (port 5001, /api/..., PostgreSQL)
 */
export const WORK_BACKEND = {
  potion: "system",
  jashindk: "system",
  omagun: "system",
  perfect_addi: "system",
  yofukashi: "app",
  chi: "app",
  higurashi: "app",
  jashindp: "app",
  irene: "app",
};

/**
 * 指定した作品が system/ バックエンドを使うかどうかを返す
 */
export const isSystemWork = (work) =>
  WORK_BACKEND[work] === "system";

/**
 * 見た目と文言を借りる作品
 *
 * 同じ作品を App と System の両方で出すとき、System 側の URL（Sekai 名）から
 * App 側の内容（テーマ・翻訳・画像・FAQ・ガイドライン・Others）を引く。
 * 例: 邪神ちゃんドロップキックは App が jashindp、System（メデューサ）が jashindk。
 */
export const WORK_CONTENT = {
  jashindk: "jashindp",
};

export const contentWorkOf = (work) => WORK_CONTENT[work] || work;
